import GLPK from 'glpk.js'
import { k_combinations } from '@/utils/combinations'
import strings from '../lang/Strings'
const desvio = (res, exigencias, nutrientes) => {
  let sum = 0.0
  for (let e in nutrientes) {
    let min = exigencias['minimo'][e]
    let max = exigencias['maximo'][e]
    if (e === 'CMS') {
      min = exigencias['maximo'][e] * 0.80
    }
    let qtd = 0.0
    let dieta = res.result.vars
    for (let al in dieta) {
      if (!nutrientes[e][al]) continue
      let qtdAl = dieta[al] * nutrientes[e][al]
      if (al === '42-52|0|600' && parseFloat(qtdAl) > 0.310) {
        qtd += 999999999999999
      }

      qtd += qtdAl
    }
    if (qtd > max) {
      if (e === 'CMS') sum += (qtd - max) * 100
      else sum += (qtd - max) * 10
    } else if (qtd < min) {
      sum += (min - qtd) * 10
    }
    // se for um absurdo
    if (qtd > (max * 2)) {
      sum += Math.pow((qtd - max), 2)
    }
  }
  return sum
}
export const simplexSolver = async ({ dataSimplex }, callback = null) => {
  let custos = dataSimplex.custo
  let nomes = dataSimplex.nomes
  let restricoes = dataSimplex.restricoes
  let nutrientes = dataSimplex.nutrientes
  let exigencias = dataSimplex.exigencias
  let volumosos = dataSimplex.volumosos
  let proporcaoVC = dataSimplex.proporcaoVC
  const glpk = await GLPK()
  function montaFuncaoObjetivo (nomes, custos) {
    let vars = []
    for (let alimentoID in nomes) {
      vars.push({ name: alimentoID, coef: custos[alimentoID] ? custos[alimentoID] : 0.1 })
    }
    return vars
  }
  function montaRestricoesExigencias (nomes, exigencias, nutrientes) {
    let ex = []
    for (let nutriente in nutrientes) {
      let vars = []
      if (exigencias['minimo'][nutriente] === null) {
        exigencias['minimo'][nutriente] = exigencias['maximo'][nutriente] * 0.3
      }
      for (let alimentoID in nomes) {
        if (isNaN(nutrientes[nutriente][alimentoID])) continue
        vars.push({ name: alimentoID, coef: nutrientes[nutriente][alimentoID] ? nutrientes[nutriente][alimentoID] : 0 })
      }
      if (isNaN(exigencias['minimo'][nutriente])) continue
      ex.push({
        name: `exigencias_min_${nutriente}`,
        vars: vars,
        bnds: { type: glpk.GLP_LO, ub: 999999, lb: exigencias['minimo'][nutriente] }
      })
    }
    for (let nutriente in nutrientes) {
      let vars = []
      for (let alimentoID in nomes) {
        vars.push({ name: alimentoID, coef: nutrientes[nutriente][alimentoID] ? nutrientes[nutriente][alimentoID] : 0 })
      }
      if (isNaN(exigencias['minimo'][nutriente])) continue
      ex.push({
        name: `exigencias_max_${nutriente}`,
        vars: vars,
        bnds: { type: glpk.GLP_UP, ub: exigencias['maximo'][nutriente], lb: 0.0 }
      })
    }
    return ex
  }
  function montaRestricoesAlimentos (restricoes) {
    let rest = []
    for (let alimentoID in nomes) {
      let val = { 'min': 0.0, 'max': 99999 }
      if (restricoes && restricoes['minimo'] && restricoes['minimo'][alimentoID]) {
        val['min'] = restricoes['minimo'] && restricoes['minimo'][alimentoID] ? restricoes['minimo'][alimentoID] : 0
      }
      if (restricoes && restricoes['maximo'] && restricoes['maximo'][alimentoID]) {
        val['max'] = restricoes['maximo'] && restricoes['maximo'][alimentoID] ? restricoes['maximo'][alimentoID] : 99999
      }
      if (!restricoes || ((!restricoes['maximo'] || !restricoes['maximo'][alimentoID]) && (!restricoes['minimo'] || !restricoes['minimo'][alimentoID]))) continue
      let vars = [
        { name: alimentoID, coef: 1 }
      ]
      rest.push({
        name: `restricao_min_${alimentoID}`,
        vars: vars,
        bnds: { type: glpk.GLP_LO, ub: 999999, lb: val['min'] }
      })
      rest.push({
        name: `restricao_max_${alimentoID}`,
        vars: vars,
        bnds: { type: glpk.GLP_UP, ub: val['max'], lb: 0.0 }
      })
    }
    return rest
  }
  function montaRestricoesVC (nutrientes, volumosos, proporcaoVC) {
    let rest = []
    let cms = nutrientes.CMS ? nutrientes.CMS : []
    let cms_max = exigencias.maximo.CMS
    let vars = []
    if (cms.length === 0 || volumosos.length === 0 || !proporcaoVC) return rest
    for (let alimentoID of volumosos) {
      vars.push({ name: alimentoID, coef: cms[alimentoID] })
    }
    vars.push({ name: 'AUX_CMS_TOTAL', coef: (-1) * (proporcaoVC / 100) })
    rest.push({
      name: `vc_min`,
      vars: vars,
      bnds: { type: glpk.GLP_LO, ub: 999999, lb: 0.0 }
    })
    rest.push({
      name: `vc_max`,
      vars: vars,
      bnds: { type: glpk.GLP_UP, ub: 0.0, lb: 0.0 }
    })
    return rest
  }
  function montaRestricoesAuxiliares (nutrientes) {
    let rest = []
    let cms = nutrientes.CMS ? nutrientes.CMS : []
    let exCMS = exigencias['maximo']['CMS'] ? exigencias['maximo']['CMS'] : 9
    let vars = []
    if (cms.length === 0 || volumosos.length === 0) return rest
    for (let alimentoID in cms) {
      vars.push({ name: alimentoID, coef: cms[alimentoID] })
    }
    vars.push({ name: 'AUX_CMS_TOTAL', coef: -1 })
    rest.push({
      name: `vc_aux`,
      vars: vars,
      bnds: { type: glpk.GLP_FX, ub: 0, lb: 0.0 }
    })
    // 4% de MS
    rest.push({
      name: `4pc_ms`,
      vars: [{ name: 'AUX_CMS_TOTAL', coef: 1 }],
      bnds: { type: glpk.GLP_LO, ub: 0, lb: exCMS * 0.04 }
    })
    return rest
  }

  function print (res) {
    console.log(JSON.stringify(res, null, 2))
  };

  const lp = {
    name: 'LP',
    objective: {
      direction: glpk.GLP_MIN,
      name: 'obj',
      vars: montaFuncaoObjetivo(nomes, custos)
    },
    subjectTo: [
      ...montaRestricoesExigencias(nomes, exigencias, nutrientes),
      ...montaRestricoesAlimentos(restricoes),
      ...montaRestricoesAuxiliares(nutrientes),
      ...montaRestricoesVC(nutrientes, volumosos, proporcaoVC)
    ],
    options: {
      msglev: glpk.GLP_MSG_OFF
    }
  }

  const opt = {
    cb: {
      call: res => {
        print(res)
      },
      each: 1
    }
  }

  /* glpk.solve(lp)
    .then(res => {
      print(res)
    })
    .catch(err => {

      if (callback) callback(err)
      else print(err)
    }) */

  return new Promise(async (resolve, reject) => {
    glpk.solve(lp)
      .then(async res => {
        await glpk.terminate()
        if (!res || !res.result || res.result.status !== 5 || res.result.z <= 0) {
          reject(res)
          return
        }
        if (callback) callback(res)
        else resolve(res)
      })
      .catch(async err => {
        await glpk.terminate()
        if (callback) callback(err)
        else reject(res)
      })
  })

  // window.document.getElementById('cplex').innerHTML = await glpk.write(lp)
}
export const calculaSimplex = async ({ dataSimplex, exigenciasSelecionadas = {}, type = 'removerExigencias' }, callback = null) => {
  let exigencias = dataSimplex.exigencias
  let nomes = dataSimplex.nomes
  if (Object.keys(exigenciasSelecionadas).length === 0) {
    return simplexSolver({ dataSimplex }, callback)
  }
  function removerExigencias (exigencias, exigenciasSelecionadas) {
    let exigencias_ = JSON.parse(JSON.stringify(exigencias))
    for (let ex in exigencias['minimo']) {
      if (!exigenciasSelecionadas.includes(ex)) {
        delete exigencias_['minimo'][ex]
        delete exigencias_['maximo'][ex]
      }
    }
    return exigencias_
  }
  function relaxarExigencias (exigencias, exigenciasSelecionadas) {
    let exigencias_ = JSON.parse(JSON.stringify(exigencias))
    for (let ex in exigencias['minimo']) {
      if (!exigenciasSelecionadas.includes(ex)) {
        exigencias_['minimo'][ex] = 0.5
        exigencias_['maximo'][ex] *= 1.5
      }
    }
    return exigencias_
  }
  let dataSimplex_ = JSON.parse(JSON.stringify(dataSimplex))
  // dataSimplex_.exigencias = removerExigencias(exigencias, exigenciasSelecionadas)
  dataSimplex_.exigencias = ((type === 'relaxarExigencias') ? relaxarExigencias : removerExigencias)(exigencias, exigenciasSelecionadas)
  return simplexSolver({ dataSimplex: dataSimplex_ }, callback)
}
export const simplex = async ({ dataSimplex }, callback = null) => {
  const prot = ['PDR', 'PNDR', 'PB', 'PM']
  const ener = ['EL', 'EM', 'NDT']
  const others = ['CMS']
  const exigencias_macro = ['Ca', 'P', 'Mg', 'K', 'Na', 'S']
  const exigencias_micro = ['Co', 'Cu', 'I', 'Mn', 'Se', 'Zn']
  if (callback === null) {
    callback = (res) => {
      console.log({ res })
    }
  }
  let respostas = []
  return new Promise(async (resolve, reject) => {
    // 1°> calcula com todas as restricoes;
    let ex = Object.keys(dataSimplex.exigencias['minimo'])
    let iteracao = 0

    try {
      let res = await calculaSimplex({ dataSimplex })
      iteracao++
      if (res.result.status === 5) {
        respostas.push([res, ex, 0, iteracao])
        callback(res, ex, 0)
        resolve(res, ex, 0)
        return
      } else throw res
    } catch (e) {
      for (let k in [5, 4, 3, 2, 1]) {
        let ex_ = ex.filter(e => !exigencias_macro.includes(e) && !exigencias_micro.includes(e))
        let permutacoes = k_combinations(ex_, k)
        let i = 0
        // testo com micro e macro-minerais fixos e relaxamento das outras exigencias fora da permutação
        for (let exigenciasCJ of permutacoes) {
          i++
          iteracao++
          if (i > 10) break
          try {
            let exigenciasFixas = [...exigenciasCJ, ...exigencias_macro, ...exigencias_micro]
            let res = await calculaSimplex({ dataSimplex, exigenciasSelecionadas: exigenciasFixas, type: 'relaxarExigencias' })
            if (res.result.status === 5) {
              respostas.push([res, exigenciasFixas, desvio(res, dataSimplex.exigencias, dataSimplex.nutrientes), iteracao])
            }
          } catch (ee) {}
        }
        i = 0
        for (let exigenciasCJ of permutacoes) {
          i++
          iteracao++
          if (i > 10) break
          try {
            let exigenciasFixas = [...exigenciasCJ, ...exigencias_macro]
            let res = await calculaSimplex({ dataSimplex, exigenciasSelecionadas: exigenciasFixas, type: 'removerExigencias' })
            if (res.result.status === 5) {
              respostas.push([res, exigenciasFixas, desvio(res, dataSimplex.exigencias, dataSimplex.nutrientes), iteracao])
            }
          } catch (ee) {}
        }
        i = 0
        for (let exigenciasCJ of permutacoes) {
          i++
          iteracao++
          if (i > 10) break
          try {
            let exigenciasFixas = [...exigenciasCJ]
            let res = await calculaSimplex({ dataSimplex, exigenciasSelecionadas: exigenciasFixas, type: 'relaxarExigencias' })
            if (res.result.status === 5) {
              respostas.push([res, exigenciasFixas, desvio(res, dataSimplex.exigencias, dataSimplex.nutrientes), iteracao])
            }
          } catch (ee) {}
        }
      }

      if (respostas.length === 0) reject(e)
      else {
        respostas = respostas.sort((r1, r2) => {
          return ((r1[2] - r2[2]))
        })
        callback(respostas[0][0], respostas[0][1], respostas[0][2])
        resolve(respostas[0][0], respostas[0][1], respostas[0][2])
      }
    }
  })
}
export const solverSuplemento = async ({ pbObjetivo = null, alimentos = {}}, callback = null) => {
  const glpk = await GLPK()
  const montaFuncaoObjetivo = (alimentos) => {
      let vars = []
      for (let alimento of alimentos) {
        let alimentoID = alimento.id
        let val = 0
        for (let ingrediente in alimento['nutrientes']) {
          if(isNaN(alimento['nutrientes'][ingrediente])) continue
          if (ingrediente === 'MS') val += (alimento['nutrientes']['MS'] / 100)
          else val += (alimento['nutrientes'][ingrediente] / 100) * (alimento['nutrientes']['MS'] / 100)
        }
        vars.push({ name: alimentoID, coef: val })
      }
      return vars
    
  }
  const montaRestricoes = (alimentos) => {
    let rest = []
    let vars = []
    for (let alimento of alimentos) {
      let alimentoID = alimento.id
      vars.push({ name: alimentoID, coef: 1 })
    }
    rest.push({
      name: `limite_suplemento`,
      vars: vars,
      bnds: { type: glpk.GLP_FX, ub: 1.0, lb: 1.0}
    })
    vars = []
    for (let alimento of alimentos) {
      let alimentoID = alimento.id
      vars.push({ name: alimentoID, coef: alimento ? (alimento['nutrientes']['MS'] / 100) * (alimento['nutrientes']['PB'] / 100) : 0.1 })
    }
    rest.push({
      name: `limite_suplemento_pb`,
      vars: vars,
      bnds: { type: glpk.GLP_FX, ub: pbObjetivo / 100, lb: pbObjetivo / 100}
    })
    for (let alimento of alimentos) {
      let alimentoID = alimento.id
      if (alimento.minimo === null) continue
      let min = parseFloat(alimento.minimo.replace(',','.'))
      if (min <= 0 || isNaN(min)) continue
      rest.push({
        name: `limite_suplemento_${alimentoID}_min`,
        vars: [{name: alimentoID, coef: 1}],
        bnds: { type: glpk.GLP_LO, ub: 1, lb: min / 100}
      })
      rest.push({
        name: `limite_suplemento_${alimentoID}_min_zero`,
        vars: [{name: alimentoID, coef: 1}],
        bnds: { type: glpk.GLP_LO, ub: 1, lb: 0}
      })
    }
    for (let alimento of alimentos) {
      let alimentoID = alimento.id
      if (alimento.maximo === null) continue
      let max = parseFloat(alimento.maximo.replace(',','.'))
      if (max <= 0 || isNaN(max)) continue
      rest.push({
        name: `limite_suplemento_${alimentoID}_max`,
        vars: [{name: alimentoID, coef: 1}],
        bnds: { type: glpk.GLP_UP, ub: max / 100, lb: 0}
      })
    }
    return rest
  }
  const lp = {
    name: 'LP',
    objective: {
      direction: glpk.GLP_MAX,
      name: 'obj',
      vars: montaFuncaoObjetivo(alimentos)
    },
    subjectTo: [
      ...montaRestricoes(alimentos, pbObjetivo)
    ],
    options: {
      msglev: glpk.GLP_MSG_OFF
    }
  }
  return new Promise(async (resolve, reject) => {
    glpk.solve(lp)
      .then(async res => {
        await glpk.terminate()
        if (!res || !res.result || res.result.status !== 5 || res.result.z <= 0) {
          reject(res)
          return
        }
        if (callback) callback(res)
        else resolve(res)
      })
      .catch(async err => {
        await glpk.terminate()
        if (callback) callback(err)
        else reject(res)
      })
  })

}
